// @ts-nocheck
import * as React from 'react';
import * as Scroll from 'react-scroll';
import ProgressRing from 'components/ProgressRing/index';
import { ReactComponent as ArrowUpIcon } from 'assets/svg/arrow_up.svg';
import SvgImageWrapper from 'components/SvgImage/SvgImage.style';
import GoTopWrapper from './GoTop.styles';

const scroll = Scroll.animateScroll;

const GoTop = (): React.ReactElement<any> | null => {
  const [show, setShow] = React.useState(false);
  const [triggerAnimation, setTriggerAnimation] = React.useState(false);
  const [scrollProgress, setScrollProgress] = React.useState(0);
  const animationClass = show && triggerAnimation ? 'flipInX' : 'flipOutX';

  const handleScroll = () => {
    // $FlowFixMe
    const totalDocScrollLength = document.documentElement.offsetHeight - window.innerHeight;
    setScrollProgress(Math.floor((window.pageYOffset / totalDocScrollLength) * 100));

    if (window.scrollY > window.innerHeight) {
      setShow(true);
      setTriggerAnimation(true);
    } else {
      setShow(false);
      setTriggerAnimation(false);
    }
  };

  const goTopHandler = () => {
    scroll.scrollToTop({
      duration: 400,
    });
  };

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return show ? (
    <GoTopWrapper
      className={animationClass}
      onClick={goTopHandler}
      onKeyPress={goTopHandler}
      role='button'
      aria-hidden='true'
    >
      <SvgImageWrapper className='go-top__icon' color='#fff'>
        <ArrowUpIcon />
      </SvgImageWrapper>
      <ProgressRing
        className='go-top__progress-ring'
        radius={21}
        strokeColor='white'
        strokeWidth={2}
        progress={scrollProgress}
      />
    </GoTopWrapper>
  ) : null;
};

export default GoTop;
